import React, { useState, useEffect } from 'react';
import { devCenter } from '../../services/api';
import { Plus, Edit2 } from 'lucide-react';

const WorkItemsManager = () => {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchItems();
    }, []);

    const fetchItems = async () => {
        try {
            const res = await devCenter.getWorkItems();
            setItems(res.data);
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <div className="text-slate-500">Loading work items...</div>;

    return (
        <div className="bg-slate-800/50 border border-slate-700/50 rounded-xl p-5">
            <div className="flex justify-between items-center mb-6">
                <h3 className="text-lg font-medium text-white">Work Items</h3>
                <button className="flex items-center gap-2 bg-blue-600 hover:bg-blue-500 text-white px-3 py-1.5 rounded-lg text-sm transition-colors">
                    <Plus size={16} /> New Item
                </button>
            </div>
            
            <div className="space-y-2">
                {items.length === 0 ? (
                    <div className="text-center py-8 text-slate-500 text-sm">No work items found.</div>
                ) : (
                    items.map(item => (
                        <div key={item.id} className="flex justify-between items-center bg-slate-800 p-3 rounded-lg border border-slate-700 hover:border-slate-500 transition-colors">
                            <div>
                                <div className="text-white font-medium text-sm flex items-center gap-2">
                                    <span className="bg-slate-700 text-slate-300 text-[10px] uppercase font-bold px-1.5 py-0.5 rounded">{item.type}</span>
                                    {item.title}
                                </div>
                                <div className="text-xs text-slate-400 mt-1">{item.summary || "No summary provided."}</div>
                            </div>
                            <div className="flex items-center gap-4">
                                <span className="text-xs font-semibold px-2 py-1 rounded bg-slate-900 text-slate-300 border border-slate-700">
                                    {item.status}
                                </span>
                                <button className="text-slate-500 hover:text-white transition-colors">
                                    <Edit2 size={16} />
                                </button>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default WorkItemsManager;
